import { extractEmailAddress } from "@/lib/compose/composeDraft";
import type { MailContactCollectEntry } from "@/lib/types/contact";

/** Découpe une ligne destinataires (À/Cc) en entrées collectables. */
export function parseAddressFieldEntries(raw: string): MailContactCollectEntry[] {
  const normalized = raw.trim().replace(/[\r\n;]+/g, ",");
  if (!normalized) return [];

  const parts = normalized.split(/,(?=(?:[^"]*"[^"]*")*[^"]*$)/);
  const out: MailContactCollectEntry[] = [];
  const seen = new Set<string>();

  for (const part of parts) {
    const trimmed = part.trim().replace(/^["']|["']$/g, "");
    if (!trimmed) continue;

    const email = extractEmailAddress(trimmed).toLowerCase();
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) || seen.has(email)) continue;

    let displayName: string | null = null;
    const angle = trimmed.match(/^(.+?)<[^>]+>$/);
    if (angle?.[1]) {
      displayName = angle[1].trim().replace(/^["']|["']$/g, "") || null;
    }

    seen.add(email);
    out.push({ email, displayName });
  }

  return out;
}

/** Token en cours de frappe après la dernière virgule. */
export function activeAddressToken(raw: string, caret: number): string {
  const before = raw.slice(0, Math.max(0, caret));
  const lastComma = before.lastIndexOf(",");
  return before.slice(lastComma + 1).trim();
}

export function replaceActiveAddressToken(raw: string, caret: number, replacement: string): string {
  const before = raw.slice(0, Math.max(0, caret));
  const after = raw.slice(Math.max(0, caret));
  const lastComma = before.lastIndexOf(",");
  const prefix = lastComma >= 0 ? before.slice(0, lastComma + 1) + " " : "";
  const tail = after.trimStart();
  const suffix = tail
    ? (tail.startsWith(",") ? "" : ", ") + tail.replace(/^,\s*/, "")
    : ", ";
  const next = `${prefix}${replacement}${suffix}`;
  return next.replace(/\s+,/g, ",").replace(/,\s*,+/g, ", ");
}
